import { createFileRoute } from "@tanstack/react-router";
import { KontraktRaportPage } from "@/features/contracts/kontrakt-raport-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/raporty/kontrakt")({
	component: KontraktRaportPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.raporty-kontrakt",
			location.pathname,
		);
	},
});
